// GENERATED by scripts/generate-free-templates.ts. Do not edit by hand.
// Byte sizes of the template files, shown on the download cards.
import type { FreeTemplateFormat, FreeTemplateId } from "./free-template-catalog";

export const FREE_TEMPLATE_FILE_BYTES: Readonly<Record<FreeTemplateId, Readonly<Record<FreeTemplateFormat, number>>>> = {
  "rams": { pdf: 127045, docx: 65113 },
  "method-statement": { pdf: 117322, docx: 55390 },
  "risk-assessment": { pdf: 92531, docx: 48150 },
  "coshh": { pdf: 113815, docx: 52029 },
  "toolbox-talk": { pdf: 103756, docx: 40057 },
  "site-induction": { pdf: 114130, docx: 47663 },
  "cpp": { pdf: 120911, docx: 53816 },
  "hot-work-permit": { pdf: 122126, docx: 48489 },
  "confined-space-permit": { pdf: 130250, docx: 58716 },
  "permit-to-dig": { pdf: 119584, docx: 47001 },
  "roof-work-permit": { pdf: 116889, docx: 41142 },
  "electrical-isolation-permit": { pdf: 113326, docx: 36743 },
  "scaffold-inspection-register": { pdf: 104874, docx: 44434 },
  "excavation-inspection-register": { pdf: 106599, docx: 45173 },
  "ladder-pre-use-check": { pdf: 104454, docx: 39018 },
  "mewp-pre-use-check": { pdf: 111436, docx: 41262 },
  "plant-pre-use-check": { pdf: 117464, docx: 42668 },
  "temporary-works-register": { pdf: 89061, docx: 41549 },
  "welfare-setup-checklist": { pdf: 102439, docx: 27306 },
  "principal-contractor-checklist": { pdf: 89886, docx: 28855 },
  "asbestos-stop-work-checklist": { pdf: 92150, docx: 30713 },
  "christmas-shutdown-checklist": { pdf: 92532, docx: 33008 },
  "january-restart-checklist": { pdf: 100642, docx: 33338 },
  "emergency-plan": { pdf: 132850, docx: 68349 },
};

/** Trade RAMS templates (SEO plan row 25), keyed by trade slug. */
export const TRADE_RAMS_TEMPLATE_FILE_BYTES: Readonly<Record<string, Readonly<Record<FreeTemplateFormat, number>>>> = {
  "electricians": { pdf: 162816, docx: 80737 },
  "plumbers": { pdf: 184222, docx: 86678 },
  "builders": { pdf: 186045, docx: 92726 },
  "roofers": { pdf: 185330, docx: 87359 },
  "carpenters": { pdf: 163107, docx: 81847 },
  "joiners": { pdf: 163059, docx: 81832 },
  "plasterers": { pdf: 173236, docx: 84811 },
  "painters-decorators": { pdf: 174365, docx: 84886 },
  "bricklayers": { pdf: 168974, docx: 84088 },
  "groundworkers": { pdf: 180767, docx: 90163 },
  "landscapers": { pdf: 168894, docx: 83944 },
  "scaffolders": { pdf: 162352, docx: 80246 },
  "demolition-contractors": { pdf: 178407, docx: 88401 },
  "gas-engineers": { pdf: 184273, docx: 86703 },
  "kitchen-fitters": { pdf: 163162, docx: 81872 },
  "tilers": { pdf: 173085, docx: 84791 },
  "window-fitters": { pdf: 163177, docx: 81867 },
  "fencing-contractors": { pdf: 169002, docx: 83984 },
  "drainage-contractors": { pdf: 180836, docx: 90198 },
  "steelworkers": { pdf: 167167, docx: 77678 },
  "solar-installers": { pdf: 162971, docx: 80787 },
  "heat-pump-engineers": { pdf: 184375, docx: 86733 },
  "ev-charger-installers": { pdf: 163361, docx: 80782 },
  "paving-contractors": { pdf: 169009, docx: 83979 },
  "dry-liners": { pdf: 173213, docx: 84811 },
  "cladding-contractors": { pdf: 167267, docx: 77718 },
  "stone-masons": { pdf: 168971, docx: 84093 },
  "housebuilders": { pdf: 186094, docx: 92751 },
};
